import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

export function useAllPaymentsPaginated(token, page, size, refreshCount) {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    setError(null);
    fetch(
      `${BASE_URL}subscription/admin/payments?page=${page}&size=${size}&sort=DESC`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    )
      .then((res) => {
        if (res.status === 204) return { content: [], totalPages: 0 };
        else if (res.ok) return res.json();
        else throw new Error("Erro ao buscar pagamentos");
      })
      .then((data) => {
        setPayments(data.content || []);
        setTotalPages(data.totalPages || 1);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token, page, size, refreshCount]);

  return { payments, loading, error, totalPages };
}
